// Colocated strings for StatusBreakdownCard (SKILL.md rule 11, PLATFORM.md §6 decision 15).
// Consumed by ../setup.js as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off: these keys resolve here and never touch the app's bundle.
//
// One key, the empty state's `noData` — the value issue-analysis rendered when the card moved out
// of the app (2026-10-12): `@rdrive/vocabulary`'s `noData` in all 10 locales, which this copy
// shadows (a package never imports the vocabulary). The card's title is a prop, translated by the
// page (issue-analysis: its own `issueStatusBreakdown`).
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
